import type { SummaryPartDescriptionProps } from '@/components/Summary/Part/SummaryPartDescription'
import type { SummaryPartKeyPointsProps } from '@/components/Summary/Part/SummaryPartKeyPoints'
import type { SummaryPartParallaxProps } from '@/components/Summary/Part/SummaryPartParallax'
import type { SummaryPartSliderProps } from '@/components/Summary/Part/SummaryPartSlider'

// import cap from '@/assets/images/summary/cap.png';
// import mug from '@/assets/images/summary/mug.png';
// import carrot from '@/assets/images/summary/carrot.png';
// import pizza from '@/assets/images/summary/pizza.png';
// import spider_pencil_case from '@/assets/images/summary/spider_pencil_case.png';
// import spider_calculator from '@/assets/images/summary/spider_calculator.png';
// import grocery_bag from '@/assets/images/summary/grocery_bag.png';
// import can from '@/assets/images/summary/can.png';
// import books from '@/assets/images/summary/books.png';
// import headphone from '@/assets/images/summary/headphone.png';
// import shoes from '@/assets/images/summary/shoes.png';
// import boombox from '@/assets/images/summary/boombox.png';

export const personas = ['pedro', 'caris', 'francesca']

export const questions = {
  before: ['binary', 'binary', 'binary'],
  after: ['binary', 'binary', 'binary', 'binary_explanation'],
  before_long: ['binary', 'binary', 'binary', 'likert', 'likert', 'likert', 'likert'],
  after_long: ['binary', 'binary', 'binary', 'binary_explanation', 'likert', 'likert', 'likert', 'likert'],
}
export type Persona = 'pedro' | 'caris' | 'francesca'

export type Audience = 'CHILD' | 'PARENT' | 'EDUCATOR' | 'UNSPECIFIED'

export type LTD = 'ADHD' | 'DYSLEXIA' | 'DYSCALCULIA'

export type Config = {
  persona: Persona
  scenarios: Array<{
    summary: Array<{
      type: 'parallax' | 'description' | 'slider' | 'key-points'
      props: SummaryPartParallaxProps | SummaryPartDescriptionProps | SummaryPartSliderProps | SummaryPartKeyPointsProps
    }>
  }>
}

export const configs: Config[] = [
  {
    persona: 'pedro',
    scenarios: [
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.pedro.1.key_points.title',
              text: 'summary.pedro.1.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.75,
              src: 'cap',
              alt: 'summary.pedro.1.parallax.2.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.pedro.1.description.title',
              introduction: 'summary.pedro.1.description.introduction',
              subtitle1: 'summary.pedro.1.description.subtitle1',
              text1: 'summary.pedro.1.description.text1',
              subtitle2: 'summary.pedro.1.description.subtitle2',
              text2: 'summary.pedro.1.description.text2',
              cta: {
                label: 'summary.pedro.1.description.cta.label',
                url: 'summary.pedro.1.description.cta.url',
              },
              background: 'background1',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.5,
              src: 'mug',
              alt: 'summary.pedro.1.parallax.1.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.pedro.1.slider.item.1.title',
                  text: 'summary.pedro.1.slider.item.1.text',
                  tag: 'summary.pedro.1.slider.item.1.tag',
                  type: 'summary.pedro.1.slider.item.1.type',
                  image: 'stretching',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.1.slider.item.2.title',
                  text: 'summary.pedro.1.slider.item.2.text',
                  tag: 'summary.pedro.1.slider.item.2.tag',
                  type: 'summary.pedro.1.slider.item.2.type',
                  image: 'television',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.pedro.1.slider.item.3.title',
                  text: 'summary.pedro.1.slider.item.3.text',
                  tag: 'summary.pedro.1.slider.item.3.tag',
                  type: 'summary.pedro.1.slider.item.3.type',
                  image: 'milk',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.1.slider.item.4.title',
                  text: 'summary.pedro.1.slider.item.4.text',
                  tag: 'summary.pedro.1.slider.item.4.tag',
                  type: 'summary.pedro.1.slider.item.4.type',
                  image: 'dog',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.pedro.1.slider.item.5.title',
                  text: 'summary.pedro.1.slider.item.5.text',
                  tag: 'summary.pedro.1.slider.item.5.tag',
                  type: 'summary.pedro.1.slider.item.5.type',
                  image: 'sock_doublelines',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.1.slider.item.6.title',
                  text: 'summary.pedro.1.slider.item.6.text',
                  tag: 'summary.pedro.1.slider.item.6.tag',
                  type: 'summary.pedro.1.slider.item.6.type',
                  // image: "mug",
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
              ],
            },
          },
        ],
      },
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.pedro.2.key_points.title',
              text: 'summary.pedro.2.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.5,
              src: 'carrot',
              alt: 'summary.pedro.2.parallax.1.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.pedro.2.description.title',
              introduction: 'summary.pedro.2.description.introduction',
              subtitle1: 'summary.pedro.2.description.subtitle1',
              text1: 'summary.pedro.2.description.text1',
              subtitle2: 'summary.pedro.2.description.subtitle2',
              text2: 'summary.pedro.2.description.text2',
              cta: {
                label: 'summary.pedro.2.description.cta.label',
                url: 'summary.pedro.2.description.cta.url',
              },
              background: 'background2',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.75,
              src: 'pizza',
              alt: 'summary.pedro.2.parallax.2.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.pedro.2.slider.item.1.title',
                  text: 'summary.pedro.2.slider.item.1.text',
                  tag: 'summary.pedro.2.slider.item.1.tag',
                  type: 'summary.pedro.2.slider.item.1.type',
                  image: 'clown',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.2.slider.item.2.title',
                  text: 'summary.pedro.2.slider.item.2.text',
                  tag: 'summary.pedro.2.slider.item.2.tag',
                  type: 'summary.pedro.2.slider.item.2.type',
                  image: 'fire_turbo',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.pedro.2.slider.item.3.title',
                  text: 'summary.pedro.2.slider.item.3.text',
                  tag: 'summary.pedro.2.slider.item.3.tag',
                  type: 'summary.pedro.2.slider.item.3.type',
                  image: 'pixelated_brain',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.2.slider.item.4.title',
                  text: 'summary.pedro.2.slider.item.4.text',
                  tag: 'summary.pedro.2.slider.item.4.tag',
                  type: 'summary.pedro.2.slider.item.4.type',
                  image: 'handspinner',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.pedro.2.slider.item.5.title',
                  text: 'summary.pedro.2.slider.item.5.text',
                  tag: 'summary.pedro.2.slider.item.5.tag',
                  type: 'summary.pedro.2.slider.item.5.type',
                  image: 'pizza',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.pedro.2.slider.item.6.title',
                  text: 'summary.pedro.2.slider.item.6.text',
                  tag: 'summary.pedro.2.slider.item.6.tag',
                  type: 'summary.pedro.2.slider.item.6.type',
                  image: 'narnia',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.pedro.2.slider.item.7.title',
                  text: 'summary.pedro.2.slider.item.7.text',
                  tag: 'summary.pedro.2.slider.item.7.tag',
                  type: 'summary.pedro.2.slider.item.7.type',
                  // image: "sharpener",
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    persona: 'francesca',
    scenarios: [
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.francesca.1.key_points.title',
              text: 'summary.francesca.1.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.75,
              src: 'spider_pencil_case',
              alt: 'summary.francesca.1.parallax.2.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.francesca.1.description.title',
              introduction: 'summary.francesca.1.description.introduction',
              subtitle1: 'summary.francesca.1.description.subtitle1',
              text1: 'summary.francesca.1.description.text1',
              subtitle2: 'summary.francesca.1.description.subtitle2',
              text2: 'summary.francesca.1.description.text2',
              cta: {
                label: 'summary.francesca.1.description.cta.label',
                url: 'summary.francesca.1.description.cta.url',
              },
              background: 'background1',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.5,
              src: 'spider_calculator',
              alt: 'summary.francesca.1.parallax.1.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.francesca.1.slider.item.1.title',
                  text: 'summary.francesca.1.slider.item.1.text',
                  tag: 'summary.francesca.1.slider.item.1.tag',
                  type: 'summary.francesca.1.slider.item.1.type',
                  image: 'roman_numerals',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.1.slider.item.2.title',
                  text: 'summary.francesca.1.slider.item.2.text',
                  tag: 'summary.francesca.1.slider.item.2.tag',
                  type: 'summary.francesca.1.slider.item.2.type',
                  image: 'hands_on_tool',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.francesca.1.slider.item.3.title',
                  text: 'summary.francesca.1.slider.item.3.text',
                  tag: 'summary.francesca.1.slider.item.3.tag',
                  type: 'summary.francesca.1.slider.item.3.type',
                  image: 'switch',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.1.slider.item.4.title',
                  text: 'summary.francesca.1.slider.item.4.text',
                  tag: 'summary.francesca.1.slider.item.4.tag',
                  type: 'summary.francesca.1.slider.item.4.type',
                  image: 'calculator',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.francesca.1.slider.item.5.title',
                  text: 'summary.francesca.1.slider.item.5.text',
                  tag: 'summary.francesca.1.slider.item.5.tag',
                  type: 'summary.francesca.1.slider.item.5.type',
                  image: 'barrier',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.1.slider.item.6.title',
                  text: 'summary.francesca.1.slider.item.6.text',
                  tag: 'summary.francesca.1.slider.item.6.tag',
                  type: 'summary.francesca.1.slider.item.6.type',
                  image: 'spider_invasion',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.francesca.1.slider.item.7.title',
                  text: 'summary.francesca.1.slider.item.7.text',
                  tag: 'summary.francesca.1.slider.item.7.tag',
                  type: 'summary.francesca.1.slider.item.7.type',
                  // image: "sharpener",
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
              ],
            },
          },
        ],
      },
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.francesca.2.key_points.title',
              text: 'summary.francesca.2.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.75,
              src: 'grocery_bag',
              alt: 'summary.francesca.1.parallax.2.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.francesca.2.description.title',
              introduction: 'summary.francesca.2.description.introduction',
              subtitle1: 'summary.francesca.2.description.subtitle1',
              text1: 'summary.francesca.2.description.text1',
              subtitle2: 'summary.francesca.2.description.subtitle2',
              text2: 'summary.francesca.2.description.text2',
              cta: {
                label: 'summary.francesca.2.description.cta.label',
                url: 'summary.francesca.2.description.cta.url',
              },
              background: 'background1',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.5,
              src: 'can',
              alt: 'summary.francesca.1.parallax.1.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.francesca.2.slider.item.1.title',
                  text: 'summary.francesca.2.slider.item.1.text',
                  tag: 'summary.francesca.2.slider.item.1.tag',
                  type: 'summary.francesca.2.slider.item.1.type',
                  image: 'coin_03',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.2.slider.item.2.title',
                  text: 'summary.francesca.2.slider.item.2.text',
                  tag: 'summary.francesca.2.slider.item.2.tag',
                  type: 'summary.francesca.2.slider.item.2.type',
                  image: 'price_tag_chaos',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.francesca.2.slider.item.3.title',
                  text: 'summary.francesca.2.slider.item.3.text',
                  tag: 'summary.francesca.2.slider.item.3.tag',
                  type: 'summary.francesca.2.slider.item.3.type',
                  image: 'deep_breath',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.2.slider.item.4.title',
                  text: 'summary.francesca.2.slider.item.4.text',
                  tag: 'summary.francesca.2.slider.item.4.tag',
                  type: 'summary.francesca.2.slider.item.4.type',
                  image: 'brain_freeze',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.francesca.2.slider.item.5.title',
                  text: 'summary.francesca.2.slider.item.5.text',
                  tag: 'summary.francesca.2.slider.item.5.tag',
                  type: 'summary.francesca.2.slider.item.5.type',
                  image: 'phone_calculator_alt',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
                {
                  title: 'summary.francesca.2.slider.item.6.title',
                  text: 'summary.francesca.2.slider.item.6.text',
                  tag: 'summary.francesca.2.slider.item.6.tag',
                  type: 'summary.francesca.2.slider.item.6.type',
                  image: 'receipt',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    persona: 'caris',
    scenarios: [
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.caris.1.key_points.title',
              text: 'summary.caris.1.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.75,
              src: 'books',
              alt: 'summary.caris.1.parallax.2.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.caris.1.description.title',
              introduction: 'summary.caris.1.description.introduction',
              subtitle1: 'summary.caris.1.description.subtitle1',
              text1: 'summary.caris.1.description.text1',
              subtitle2: 'summary.caris.1.description.subtitle2',
              text2: 'summary.caris.1.description.text2',
              cta: {
                label: 'summary.caris.1.description.cta.label',
                url: 'summary.caris.1.description.cta.url',
              },
              background: 'background1',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.5,
              src: 'headphone',
              alt: 'summary.caris.1.parallax.1.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.caris.1.slider.item.1.title',
                  text: 'summary.caris.1.slider.item.1.text',
                  tag: 'summary.caris.1.slider.item.1.tag',
                  type: 'summary.caris.1.slider.item.1.type',
                  // image: "headphones",
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.caris.1.slider.item.2.title',
                  text: 'summary.caris.1.slider.item.2.text',
                  tag: 'summary.caris.1.slider.item.2.tag',
                  type: 'summary.caris.1.slider.item.2.type',
                  image: 'letter_picker',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.caris.1.slider.item.3.title',
                  text: 'summary.caris.1.slider.item.3.text',
                  tag: 'summary.caris.1.slider.item.3.tag',
                  type: 'summary.caris.1.slider.item.3.type',
                  // image: "dog",
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
                {
                  title: 'summary.caris.1.slider.item.4.title',
                  text: 'summary.caris.1.slider.item.4.text',
                  tag: 'summary.caris.1.slider.item.4.tag',
                  type: 'summary.caris.1.slider.item.4.type',
                  image: 'palpitations',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.caris.1.slider.item.5.title',
                  text: 'summary.caris.1.slider.item.5.text',
                  tag: 'summary.caris.1.slider.item.5.tag',
                  type: 'summary.caris.1.slider.item.5.type',
                  image: 'journal',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
                {
                  title: 'summary.caris.1.slider.item.6.title',
                  text: 'summary.caris.1.slider.item.6.text',
                  tag: 'summary.caris.1.slider.item.6.tag',
                  type: 'summary.caris.1.slider.item.6.type',
                  // image: "socks_pair",
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.caris.1.slider.item.7.title',
                  text: 'summary.caris.1.slider.item.7.text',
                  tag: 'summary.caris.1.slider.item.7.tag',
                  type: 'summary.caris.1.slider.item.7.type',
                  // image: "socks_pair",
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
              ],
            },
          },
        ],
      },
      {
        summary: [
          {
            type: 'key-points',
            props: {
              title: 'summary.caris.2.key_points.title',
              text: 'summary.caris.2.key_points.text',
              background: 'background3',
            },
          },
          {
            type: 'parallax',
            props: {
              appear: true,
              position: 'right',
              speed: 0.75,
              src: 'shoes',
              alt: 'summary.caris.2.parallax.2.alt',
            },
          },
          {
            type: 'description',
            props: {
              title: 'summary.caris.2.description.title',
              introduction: 'summary.caris.2.description.introduction',
              subtitle1: 'summary.caris.2.description.subtitle1',
              text1: 'summary.caris.2.description.text1',
              subtitle2: 'summary.caris.2.description.subtitle2',
              text2: 'summary.caris.2.description.text2',
              cta: {
                label: 'summary.caris.2.description.cta.label',
                url: 'summary.caris.2.description.cta.url',
              },
              background: 'background1',
            },
          },
          {
            type: 'parallax',
            props: {
              position: 'left',
              speed: 0.5,
              src: 'boombox',
              alt: 'summary.caris.2.parallax.1.alt',
            },
          },
          {
            type: 'slider',
            props: {
              items: [
                {
                  title: 'summary.caris.2.slider.item.1.title',
                  text: 'summary.caris.2.slider.item.1.text',
                  tag: 'summary.caris.2.slider.item.1.tag',
                  type: 'summary.caris.2.slider.item.1.type',
                  image: 'legs_05',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.caris.2.slider.item.2.title',
                  text: 'summary.caris.2.slider.item.2.text',
                  tag: 'summary.caris.2.slider.item.2.tag',
                  type: 'summary.caris.2.slider.item.2.type',
                  image: 'phone_player',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'bottom',
                },
                {
                  title: 'summary.caris.2.slider.item.3.title',
                  text: 'summary.caris.2.slider.item.3.text',
                  tag: 'summary.caris.2.slider.item.3.tag',
                  type: 'summary.caris.2.slider.item.3.type',
                  image: 'mirror',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'top',
                },
                {
                  title: 'summary.caris.2.slider.item.4.title',
                  text: 'summary.caris.2.slider.item.4.text',
                  tag: 'summary.caris.2.slider.item.4.tag',
                  type: 'summary.caris.2.slider.item.4.type',
                  image: 'confusion',
                  iconBackground: 'background2',
                  iconBackgroundClassName: 'text-coral',
                  variant: 'bottom',
                },
                {
                  title: 'summary.caris.2.slider.item.5.title',
                  text: 'summary.caris.2.slider.item.5.text',
                  tag: 'summary.caris.2.slider.item.5.tag',
                  type: 'summary.caris.2.slider.item.5.type',
                  image: 'muscle_memory',
                  iconBackground: 'background1',
                  iconBackgroundClassName: 'text-light-blue',
                  variant: 'top',
                },
              ],
            },
          },
        ],
      },
    ],
  },
]
